/** Shared display formatting for engineering tables and detail panels
 *  (UX spec §3.10). Cells get the compact form; full precision belongs in the
 *  cell's `title` attribute, set at the call site. */

/** Whole-kW display with thousands separators: 2891.44 → "2,891". */
export function fmtKw(kw: number | null | undefined): string {
  if (kw == null || !Number.isFinite(kw)) return '—'
  return Math.round(kw).toLocaleString('en-US')
}

/** One-decimal percentage: 25.44 → "25.4%". */
export function fmtPct(pct: number | null | undefined): string {
  if (pct == null || !Number.isFinite(pct)) return '—'
  return `${pct.toFixed(1)}%`
}

/** Phase display: 1 → "1φ", 3 → "3φ" (numbers or numeric strings); letter
 *  designations ("A", "ABC") pass through verbatim; missing → "—". */
export function fmtPhase(p: number | string | null | undefined): string {
  if (p == null || p === '') return '—'
  const n = typeof p === 'number' ? p : Number(String(p).trim())
  if (Number.isInteger(n) && n >= 1 && n <= 3) return `${n}φ`
  return String(p)
}
